angular.module('picmonic-common').directive('atlasSeen', [
  function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $(window).on('scroll', checkIfSeen);

        function checkIfSeen() {
          var elementTop = element.offset().top;
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();
          if (docViewBottom > elementTop) {
            if (typeof atlasEvent !== 'undefined') {
              if (!attrs.atlasAction) {
                attrs.atlasAction = 'click';
              }

              atlasEvent('seen', attrs.atlasSeen);
            }

            if (attrs.atlasSeenFb === 'true' && typeof fbq !== 'undefined') {
              fbq('trackCustom', 'Seen', { seen: attrs.atlasSeen });
            }

            if (attrs.atlasSeenGa === 'true' && typeof send_ga !== 'undefined') {
              send_ga('event', 'Seen', attrs.atlasSeen);
            }

            $(window).off('scroll', checkIfSeen);
          }
        }
        checkIfSeen();
        scope.$on('$destroy', function () {
          $(window).off('scroll', checkIfSeen);
        });
      },
    };
  },
]);
